import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/AutonomousMaintenanceListActions";
import * as api from "../../api/AutonomousMaintenanceListApi";
import { showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getTaskList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getTaskList(action.payload);
        if (action?.payload?.fetchMoreData) {
            yield put(actions.setTaskList({ fetchMoreDataRes: data } || undefined));
        }
        if (action?.payload?.firstCall) {
            yield put(actions.setTaskList({ firstCallRes: data } || undefined));
        }
        if(action?.payload?.applyFilter) {
            yield put(actions.setTaskList({ applyFilterRes: data } || undefined));
        }
    } catch (error) {
        yield put(actions.setTaskList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getList(action) {
    try {
        const { data } = yield api.getList(action.payload);
        yield put(actions.setList(data || undefined));
    } catch (error) {
        yield put(actions.setList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getStatusList(action) {
    try {
        const { data } = yield api.getStatusList(action.payload);
        yield put(actions.setStatusList(data || undefined));
    } catch (error) {
        yield put(actions.setStatusList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getAreaList() {
    try {
        const { data } = yield api.getAreaList();
        console.log({ data });
        yield put(actions.setAreaListAutonomous(data || undefined));
    } catch (error) {
        yield put(actions.setAreaListAutonomous(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getTechnicianList() {
    try {
        const { data } = yield api.getTechnicianList();
        yield put(actions.setTechnicianList(data || undefined));
    } catch (error) {
        yield put(actions.setTechnicianList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMainListByAreaIDAutonomous(action) {
    try {
        const { data } = yield api.getMainListByAreaID(action.payload);
        yield put(actions.setMainListByAreaIDAutonomous(data || undefined));
    } catch (error) {
        yield put(actions.setMainListByAreaIDAutonomous(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getSubListById(action) {
    try {
        const { data } = yield api.getSubListById(action.payload);
        yield put(actions.setSubListByIdAutonomous(data || undefined));
    } catch (error) {
        yield put(actions.setSubListByIdAutonomous(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_POOL_LIST, getList);
    yield takeEvery(actions.Types.GET_TASKS_PAGE_AML, getTaskList);
    yield takeEvery(actions.Types.GET_STATUS_LIST, getStatusList);
    yield takeEvery(actions.Types.GET_AREA_LIST_AUTONOMOUS, getAreaList);
    yield takeEvery(actions.Types.GET_TECHNICIAN_LIST, getTechnicianList);
    yield takeEvery(actions.Types.GET_MAIN_LIST_BY_AREA_ID_AUTONOMOUS, getMainListByAreaIDAutonomous);
    yield takeEvery(actions.Types.GET_SUB_LIST_BY_AREA_ID_AUTONOMOUS, getSubListById);
}

const AutonomousMaintenanceListSaga = [fork(watchAll)];

export default AutonomousMaintenanceListSaga;
